import { PropsWithChildren } from "react";

import Card from "@/components/common/Card";
import { cn } from "@/utils/cn";

import DownloadCompanyIntroButton from "./DownloadCompanyIntroButton";
import PricingDescription from "./PricingDescription";
import PricingFeatures from "./PricingFeatures";
import PricingPrice from "./PricingPrice";
import PricingTitle from "./PricingTitle";

interface PricingCardProps extends PropsWithChildren {
  className?: string;
}

function PricingCard({ className, children }: PricingCardProps) {
  return <Card className={cn("gap-9 p-7 tablet:rounded-3xl tablet:p-10", className)}>{children}</Card>;
}

PricingCard.Title = PricingTitle;
PricingCard.Description = PricingDescription;
PricingCard.Price = PricingPrice;
PricingCard.Features = PricingFeatures;
PricingCard.DownloadCompanyIntroButton = DownloadCompanyIntroButton;

export default PricingCard;
